{
	"cardHeader": "Toegang tot je verklaringen",
	"supplierTitle": "Ben jij de leverancier van een evoZero-verklaring?",
	"supplierDescription": "Beheer de verklaringen voor je evoZero-materialen.",
	"loginButton": "Inloggen"
}
